module.exports = __webpack_public_path__ + "img/TobyImg.389bf96e.jpg";